var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-steps',{attrs:{"active":_vm.active,"finish-status":"success","align-center":""},on:{"click":_vm.aaa}},[_c('el-step',{attrs:{"title":"开户申请"}}),_c('el-step',{attrs:{"title":"绑卡提交"}}),_c('el-step',{attrs:{"title":"绑卡确认"}}),_c('el-step',{attrs:{"title":"签约"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }